import React from 'react';
import { cx } from '@emotion/css';
import { css as reactCss } from '@emotion/react';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button: React.FC<ButtonProps> = ({ children, className, ...otherProps }) => {
  return (
    <button
      className={cx(className, 'focus-visible-outline')}
      css={plainButtonStyle}
      type="button"
      {...otherProps}
    >
      {children}
    </button>
  );
};

const plainButtonStyle = reactCss({
  // reset styles
  background: 'none',
  border: 'none',
  color: 'inherit',
  cursor: 'pointer',
  outline: 'none',
  padding: '0',
});
